var exports = {
  "O": "x112a1f60--b7b1f6--offers",
};

module.exports = exports;
